import type { FormEvent } from "react";

import { hasValue } from "@repo/helpers";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import TextBox from "../basic/textBox";
import { ToggleSlider } from "../basic/toggleSlider";
import { LoginBackground } from "./background";

interface Props {
	username: string;
	setUsername: (value: string) => void;
	usernameLabel?: string;
	password: string;
	setPassword: (value: string) => void;
	passwordLabel?: string;
	rememberMe?: boolean;
	setRememberMe?: (value: boolean) => void;
	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	forgotPassword?: () => void;
	loading: boolean;
	disabled: boolean;
	description?: string;
	version?: string;
	error?: string;

	hideTlpLogo?: boolean;

	hideAppLogo?: boolean;
	appLogo?: string;

	hideBackgroundImage?: boolean;
	backgroundImage?: string;
	containerClass?: string;
}

export function LoginPage(props: Props) {
	const {
		username,
		setUsername,
		usernameLabel = "Username",
		password,
		setPassword,
		passwordLabel = "Password",
		rememberMe,
		setRememberMe,
		submitFunction,
		forgotPassword,
		loading,
		disabled,
		error,
	} = props;

	return (
		<LoginBackground title="Login" {...props}>
			<form className="grid gap-4" onSubmit={submitFunction}>
				<TextBox
					id="username"
					name="username"
					label={usernameLabel}
					value={username}
					changeHandler={setUsername}
					className="!m-0"
					disabled={disabled}
				/>
				<TextBox
					id="password"
					name="password"
					label={passwordLabel}
					value={password}
					changeHandler={setPassword}
					type="password"
					className="!m-0"
					disabled={disabled}
				/>
				{rememberMe !== undefined && (
					<ToggleSlider
						id={"rememberMeCheckbox"}
						label={"Remember Username"}
						value={rememberMe}
						changeHandler={setRememberMe}
						hideLabel
						inline
						rounded
						className="!m-0"
					/>
				)}
				{hasValue(error) && <span className="text-sm text-red-400">{error}</span>}
				<Loading loading={loading} message="Logging in..." tag="h5">
					<Button type="submit" className="w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Login
					</Button>
				</Loading>
				{forgotPassword && (
					<Button
						type="button"
						className="w-full"
						types={[ButtonTypes.Outline]}
						onClick={forgotPassword}
						disabled={loading}
					>
						Forgot Password
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
